import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

const DotSeparator = ({ className = '' }: { className?: string }) => (
  <span className={cx(styles.separator, className)}>•</span>
);

export { DotSeparator };
